module.exports = __webpack_public_path__ + "static/media/Badge_SvgExpertCategoriel_MedecineEsthetique.bbb7a603.png";